$(document).ready(function() {
  // Cấu hình mặc định cho validation
  $.validator.setDefaults({
      errorElement: 'span',
      errorClass: 'error-message',
      validClass: 'success',
      errorPlacement: function(error, element) {
          error.addClass('error-message');

          // Kiểm tra nếu element nằm trong checkbox-group
          if ($(element).closest('.checkbox-group').length) {
              // Thêm error message vào sau checkbox-group
              error.insertAfter($(element).closest('.checkbox-group'));
          } else {
              // Mặc định thêm error message sau element
              error.insertAfter(element);
          }
      },
      highlight: function(element, errorClass) {
          $(element).addClass('error').removeClass('success');
      },
      unhighlight: function(element, errorClass) {
          $(element).removeClass('error').addClass('success');
      }
  });
})